import script from "./CheckPointBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckPointBlock.vue?vue&type=script&setup=true&lang=js"

import "./CheckPointBlock.vue?vue&type=style&index=0&id=06bea5fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06bea5fa"]])

export default __exports__